import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Manual language detection — more robust than the browser detector plugin
// and avoids any compatibility issues between i18next v25 and the detector.
// Default is always English for new visitors; user can switch via navbar toggle.
function detectLanguage(): string {
  try {
    const saved = localStorage.getItem('noren_lang');
    if (saved === 'ja' || saved === 'en') return saved;
  } catch {
    // localStorage may be blocked in some sandboxed preview environments
  }
  return 'en';
}

const lng = detectLanguage();

try {
  i18n
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      debug: false,
      lng,
      resources: messages,
      interpolation: {
        escapeValue: false,
      },
    });
} catch (e) {
  console.error('i18n init failed:', e);
}

export default i18n;